import React, { Children } from 'react';
import { IconArrowLeft, IconStethoscope, IconSchool, IconHome, IconShoppingCart, IconCircleCheck, IconClock, IconPhone, IconMail, IconCalendarCheck, IconTrendingUp, IconUser, IconChevronRight } from '@tabler/icons-react';
interface CaregiverDetailPageProps {
  caregiverId: string;
}
// Mock Data
const mockCaregiverDetails: Record<string, any> = {
  '1': {
    id: '1',
    name: 'Maria',
    role: 'Mamma',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
    stats: {
      totalTasks: 45,
      completedTasks: 38,
      percentage: 84,
      weeklyTrend: '+12%'
    },
    categories: [{
      id: 'health',
      name: 'Salute',
      icon: IconStethoscope,
      color: '#B0EC9C',
      percentage: 60,
      tasks: '12/20'
    }, {
      id: 'school',
      name: 'Scuola',
      icon: IconSchool,
      color: '#AEDAFF',
      percentage: 90,
      tasks: '18/20'
    }, {
      id: 'home',
      name: 'Casa',
      icon: IconHome,
      color: '#FAD88A',
      percentage: 40,
      tasks: '8/20'
    }],
    connectedChildren: [{
      id: 'child-1',
      name: 'Sofia',
      avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
      note: 'Gestisce visite mediche e scuola'
    }, {
      id: 'child-2',
      name: 'Marco',
      avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
      note: "Si occupa dell'asilo"
    }],
    recentActivity: [{
      id: 'a1',
      title: 'Prenotato visita dentistica',
      date: 'Oggi, 10:30',
      category: 'Salute',
      categoryColor: '#B0EC9C',
      status: 'completed'
    }, {
      id: 'a2',
      title: 'Pagamento mensa scolastica',
      date: 'Ieri, 18:45',
      category: 'Scuola',
      categoryColor: '#AEDAFF',
      status: 'completed'
    }, {
      id: 'a3',
      title: 'Comprare regalo compleanno',
      date: 'Scade domani',
      category: 'Casa',
      categoryColor: '#FAD88A',
      status: 'pending'
    }],
    availability: {
      days: 'Lun - Ven',
      hours: '17:00 - 21:00',
      phone: '333 1234567',
      email: 'maria.rossi@email.com'
    }
  },
  '2': {
    id: '2',
    name: 'Luca',
    role: 'Papà',
    avatar: 'https://cdn.magicpatterns.com/uploads/7G4z2y5zxpC8H8Kk9BNvv6/felipe-salgado-zssU4tUQ-18-unsplash.jpg',
    stats: {
      totalTasks: 32,
      completedTasks: 20,
      percentage: 62,
      weeklyTrend: '-5%'
    },
    categories: [{
      id: 'home',
      name: 'Casa',
      icon: IconHome,
      color: '#FAD88A',
      percentage: 80,
      tasks: '12/15'
    }, {
      id: 'shopping',
      name: 'Spesa',
      icon: IconShoppingCart,
      color: '#DDD6FE',
      percentage: 70,
      tasks: '7/10'
    }],
    connectedChildren: [{
      id: 'child-1',
      name: 'Sofia',
      avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
      note: 'Accompagna a danza'
    }],
    recentActivity: [{
      id: 'a1',
      title: 'Spesa settimanale',
      date: 'Oggi, 18:00',
      category: 'Spesa',
      categoryColor: '#DDD6FE',
      status: 'pending'
    }, {
      id: 'a2',
      title: 'Riparazione rubinetto',
      date: 'Sabato scorso',
      category: 'Casa',
      categoryColor: '#FAD88A',
      status: 'completed'
    }],
    availability: {
      days: 'Weekend',
      hours: 'Tutto il giorno',
      phone: '333 9876543',
      email: 'luca.bianchi@email.com'
    }
  },
  '3': {
    id: '3',
    name: 'Nonna Rosa',
    role: 'Nonna',
    avatar: 'https://images.unsplash.com/photo-1566616213894-2d4e1baee5d8?w=150&h=150&fit=crop&crop=face',
    stats: {
      totalTasks: 10,
      completedTasks: 10,
      percentage: 100,
      weeklyTrend: '+0%'
    },
    categories: [{
      id: 'home',
      name: 'Casa',
      icon: IconHome,
      color: '#FAD88A',
      percentage: 100,
      tasks: '5/5'
    }],
    connectedChildren: [{
      id: 'child-2',
      name: 'Marco',
      avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
      note: 'Babysitting pomeridiano'
    }],
    recentActivity: [{
      id: 'a1',
      title: 'Preparazione torta',
      date: 'Ieri',
      category: 'Casa',
      categoryColor: '#FAD88A',
      status: 'completed'
    }],
    availability: {
      days: 'Mar, Gio',
      hours: '14:00 - 18:00',
      phone: '011 555666'
    }
  },
  '5': {
    id: '5',
    name: 'Anna',
    role: 'Baby Sitter',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    stats: {
      totalTasks: 5,
      completedTasks: 4,
      percentage: 80,
      weeklyTrend: '+20%'
    },
    categories: [{
      id: 'school',
      name: 'Scuola',
      icon: IconSchool,
      color: '#AEDAFF',
      percentage: 100,
      tasks: '4/4'
    }],
    connectedChildren: [{
      id: 'child-1',
      name: 'Sofia',
      avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
      note: 'Ritiro da scuola'
    }, {
      id: 'child-2',
      name: 'Marco',
      avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
      note: 'Ritiro da asilo'
    }],
    recentActivity: [],
    availability: {
      days: 'Lun - Ven',
      hours: '16:00 - 19:00',
      phone: '340 9988776'
    }
  }
};
export function CaregiverDetailPage({
  caregiverId
}: CaregiverDetailPageProps) {
  const caregiver = mockCaregiverDetails[caregiverId] || mockCaregiverDetails['1'];
  const getCategoryIcon = (categoryId: string) => {
    switch (categoryId) {
      case 'health':
        return IconStethoscope;
      case 'school':
        return IconSchool;
      case 'home':
        return IconHome;
      case 'shopping':
        return IconShoppingCart;
      default:
        return IconCircleCheck;
    }
  };
  return <div className="flex flex-col h-full bg-yeppy-bg" data-id="element-577">
      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4" data-id="element-578">
        {/* Profile Info Card */}
        <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 mb-4 flex items-center gap-4" data-id="element-579">
          <img src={caregiver.avatar} alt={caregiver.name} className="w-16 h-16 rounded-full object-cover border-2 border-yeppy-text border-opacity-10" data-id="element-580" />
          <div data-id="element-581">
            <h2 className="font-rubik font-bold text-lg text-yeppy-text leading-tight" data-id="element-582">
              {caregiver.name}
            </h2>
            <span className="inline-block px-2 py-0.5 rounded-full text-[10px] font-medium bg-yeppy-text bg-opacity-5 text-yeppy-text text-opacity-60 uppercase tracking-wide mt-1" data-id="element-583">
              {caregiver.role}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-584">
          <button className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white border border-yeppy-text border-opacity-15 text-yeppy-text font-poppins text-sm font-medium transition-colors" data-id="element-585">
            <IconPhone className="w-4 h-4" stroke={1.5} data-id="element-586" />
            Chiama
          </button>
          <button className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white border border-yeppy-text border-opacity-15 text-yeppy-text font-poppins text-sm font-medium transition-colors" data-id="element-587">
            <IconMail className="w-4 h-4" stroke={1.5} data-id="element-588" />
            Messaggio
          </button>
        </div>

        {/* Stats Overview */}
        <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 mb-6" data-id="element-589">
          <div className="flex items-center justify-between mb-4" data-id="element-590">
            <div className="flex items-center gap-2" data-id="element-591">
              <IconTrendingUp className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-592" />
              <h2 className="font-rubik font-semibold text-base text-yeppy-text" data-id="element-593">
                {caregiver.name}
              </h2>
            </div>
            <div className="text-right" data-id="element-594">
              <p className="font-poppins text-xs text-yeppy-text text-opacity-50 mb-1" data-id="element-595">
                Attività
              </p>
              <p className="font-poppins text-sm text-yeppy-text font-medium" data-id="element-596">
                {caregiver.stats.completedTasks} / {caregiver.stats.totalTasks}
              </p>
            </div>
          </div>
          <div className="w-full h-2 bg-yeppy-bg rounded-full overflow-hidden" data-id="element-597">
            <div className="h-full rounded-full transition-all duration-500" style={{
            width: `${caregiver.stats.percentage}%`,
            backgroundColor: '#1D2A36'
          }} data-id="element-598" />
          </div>
        </div>

        {/* Category Breakdown */}
        <div data-id="element-599">
          <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-3" data-id="element-600">
            Contributo per area
          </h2>
          <div className="space-y-3" data-id="element-601">
            {caregiver.categories.map((cat: any) => {
            const Icon = getCategoryIcon(cat.id);
            return <div key={cat.id} className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex items-center gap-4" data-id="element-602">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: `${cat.color}33`
              }} data-id="element-603">
                    <Icon className="w-5 h-5" stroke={1.5} style={{
                  color: '#1D2A36'
                }} data-id="element-604" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-605">
                    <div className="flex items-center justify-between mb-1" data-id="element-606">
                      <span className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-607">
                        {cat.name}
                      </span>
                      <span className="font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-608">
                        {cat.percentage}%
                      </span>
                    </div>
                    <div className="w-full h-1.5 bg-yeppy-bg rounded-full overflow-hidden" data-id="element-609">
                      <div className="h-full rounded-full transition-all duration-500" style={{
                    width: `${cat.percentage}%`,
                    backgroundColor: cat.color
                  }} data-id="element-610" />
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {/* Connected Children */}
        <div data-id="element-611">
          <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-3" data-id="element-612">
            Si occupa di
          </h2>
          <div className="space-y-3" data-id="element-613">
            {caregiver.connectedChildren.map((child: any) => <div key={child.id} className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-3 flex items-center gap-3" data-id="element-614">
                <img src={child.avatar} alt={child.name} className="w-10 h-10 rounded-full object-cover border border-yeppy-text border-opacity-10" data-id="element-615" />
                <div data-id="element-616">
                  <p className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-617">
                    {child.name}
                  </p>
                  <p className="font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-618">
                    {child.note}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Recent Activity */}
        <div data-id="element-619">
          <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-3" data-id="element-620">
            Attività recenti
          </h2>
          {caregiver.recentActivity.length > 0 ? <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl overflow-hidden divide-y divide-yeppy-text divide-opacity-5" data-id="element-621">
              {caregiver.recentActivity.map((activity: any) => <div key={activity.id} className="p-4 flex items-center gap-3 hover:bg-yeppy-bg hover:bg-opacity-30 transition-colors" data-id="element-622">
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${activity.status === 'completed' ? 'bg-yeppy-green bg-opacity-20 text-yeppy-green' : 'bg-yeppy-text bg-opacity-10 text-yeppy-text text-opacity-40'}`} data-id="element-623">
                    {activity.status === 'completed' ? <IconCircleCheck className="w-3.5 h-3.5" stroke={1.5} data-id="element-624" /> : <IconClock className="w-3.5 h-3.5" stroke={1.5} data-id="element-625" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-626">
                    <p className="font-poppins text-sm text-yeppy-text truncate" data-id="element-627">
                      {activity.title}
                    </p>
                    <div className="flex items-center gap-2 mt-0.5" data-id="element-628">
                      <div className="flex items-center gap-1" data-id="element-629">
                        <div className="w-1.5 h-1.5 rounded-full" style={{
                    backgroundColor: activity.categoryColor
                  }} data-id="element-630" />
                        <span className="font-poppins text-[10px] text-yeppy-text text-opacity-50" data-id="element-631">
                          {activity.category}
                        </span>
                      </div>
                      <span className="text-[10px] text-yeppy-text text-opacity-30" data-id="element-632">
                        •
                      </span>
                      <span className="font-poppins text-[10px] text-yeppy-text text-opacity-50" data-id="element-633">
                        {activity.date}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div> : <div className="text-center py-6 bg-white border border-yeppy-text border-opacity-10 rounded-2xl" data-id="element-634">
              <p className="font-poppins text-xs text-yeppy-text text-opacity-40" data-id="element-635">
                Nessuna attività recente
              </p>
            </div>}
        </div>

        {/* Availability / Contact */}
        {caregiver.availability && <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4" data-id="element-636">
            <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-3" data-id="element-637">
              Disponibilità e Contatti
            </h2>
            <div className="space-y-3" data-id="element-638">
              <div className="flex items-center gap-3" data-id="element-639">
                <IconCalendarCheck className="w-4 h-4 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-640" />
                <span className="font-poppins text-sm text-yeppy-text" data-id="element-641">
                  {caregiver.availability.days} · {caregiver.availability.hours}
                </span>
              </div>
              {caregiver.availability.phone && <div className="flex items-center gap-3" data-id="element-642">
                  <IconPhone className="w-4 h-4 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-643" />
                  <span className="font-poppins text-sm text-yeppy-text" data-id="element-644">
                    {caregiver.availability.phone}
                  </span>
                </div>}
              {caregiver.availability.email && <div className="flex items-center gap-3" data-id="element-645">
                  <IconMail className="w-4 h-4 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-646" />
                  <span className="font-poppins text-sm text-yeppy-text" data-id="element-647">
                    {caregiver.availability.email}
                  </span>
                </div>}
            </div>
          </div>}
      </div>
    </div>;
}